module.exports = __webpack_public_path__ + "img/support_en.92daa43.jpg";